module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "id": "salesforcelogo",
      "src": "dist/SalesforceLogo.svg"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "title"
    }
  }, [_c('h1', [_vm._v("Service Cloud Snap-ins")]), _vm._v(" "), _c('h2', [_vm._v("iOS Reference Documentation")])]), _vm._v(" "), _c('p', [_vm._v("To learn how to use this SDK, see the "), _c('a', {
    attrs: {
      "href": "https://developer.salesforce.com/docs/atlas.en-us.noversion.service_sdk_ios.meta/service_sdk_ios/servicesdk_ios_dev_guide.htm"
    }
  }, [_vm._v("Snap-ins Developer's Guide for iOS")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("To see the release notes, check out our "), _c('a', {
    attrs: {
      "href": "https://github.com/forcedotcom/ServiceSDK-iOS/releases"
    }
  }, [_vm._v("Release Notes page")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5f3a3d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/DashboardHeader.vue
// module id = 13
// module chunks = 0